/**
 * Краткий буфер FA-таблицы page/forms на время WS `putFullData`.
 * Overlay ленты читает его до getFullData, когда snapshot pageData ещё без temp.
 */
import {
  pickPreferredFileAttachmentsField,
  uniDataTableToFileItems,
} from '@/common/utils/fileAttachmentsUniData'
import type { FileItem } from '@/common/types/fileItem'

const wireTablesByFieldName = new Map<string, unknown>()

function normalizeFieldName(fieldName: string): string {
  return String(fieldName ?? '').trim()
}

export function setAttachmentPutFullDataWireTable(fieldName: string, table: unknown): void {
  const name = normalizeFieldName(fieldName)
  if (!name) return
  if (table === undefined || table === null) {
    wireTablesByFieldName.delete(name)
    return
  }
  wireTablesByFieldName.set(name, table)
}

export function stashAttachmentPutFullDataWireTable(
  fieldName: string,
  ...candidates: unknown[]
): void {
  setAttachmentPutFullDataWireTable(
    fieldName,
    pickPreferredFileAttachmentsField(...candidates),
  )
}

export function peekAttachmentPutFullDataWireTable(fieldName: string): unknown {
  const name = normalizeFieldName(fieldName)
  if (!name) return undefined
  return wireTablesByFieldName.get(name)
}

export function collectAttachmentPutFullDataWireRows(fieldName: string): FileItem[] {
  return uniDataTableToFileItems(peekAttachmentPutFullDataWireTable(fieldName))
}

export function clearAttachmentPutFullDataWireTable(fieldName?: string): void {
  const name = fieldName == null ? '' : normalizeFieldName(fieldName)
  if (!name) {
    wireTablesByFieldName.clear()
    return
  }
  wireTablesByFieldName.delete(name)
}
